import {logOut} from "../slices/auth.slice";
import {PayloadAction} from "@reduxjs/toolkit";

export const AuthorizationMiddleware = ({dispatch}: {dispatch: any}) => (next: any) => (action: PayloadAction<{status: number}>) => {
    if (action.type.endsWith('/rejected') && action.payload?.status === 401) {
        dispatch(logOut());
    }
    return next(action);
}